import { ReactElement, ReactNode } from "react";
import FlexLayoutItem, {
  layouts,
} from "@jnctn/design-system/Flexbox/FlexLayoutItem.component";
import Text from "@jnctn/design-system/Text/Text.component";
import { motion } from "motion/react";
import cx from "classnames";

export default function Notice({
  text,
  actions = [],
  type = "default",
  icon,
}: {
  type?: "default" | "attention" | "negative";
  text: string;
  actions?: ReactNode[];
  icon?: ReactElement;
}) {
  return (
    <FlexLayoutItem
      className={cx("rounded-full p-3 px-5", {
        "bg-ocean-400": type === "attention",
        "bg-charcoal-800": type === "default",
        "bg-red-500": type === "negative",
      })}
      element={
        <motion.div
          initial={{ opacity: 0, y: 300 }}
          animate={{ opacity: 1, y: 0 }}
        />
      }
    >
      {actions.length > 0 ? (
        <FlexLayoutItem layout={layouts.horizontalCenter}>
          {icon ? (
            <FlexLayoutItem className="mr-3">{icon}</FlexLayoutItem>
          ) : null}
          <FlexLayoutItem grow={1} align="center" className="mr-2">
            <Text size="body1" color="white">
              {text}
            </Text>
          </FlexLayoutItem>
          {actions.length
            ? actions.map((action, key) => (
                <FlexLayoutItem
                  className="ml-2"
                  key={key}
                  layout={layouts.horizontalCenter}
                >
                  {action}
                </FlexLayoutItem>
              ))
            : null}
        </FlexLayoutItem>
      ) : (
        <Text size="body1" color="white">
          {text}
        </Text>
      )}
    </FlexLayoutItem>
  );
}

